import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/userinfo/copy.svg';
import _imports_1 from '@/assets/image/userinfo/edit.png';
import _imports_2 from '@/assets/image/userinfo/user_edit.png';
import _imports_3 from '@/assets/image/userinfo/right.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2b57eb9c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "shoppingCart"
};
var _hoisted_2 = {
  "class": "user-box",
  style: {
    "height": "100%"
  }
};
var _hoisted_3 = {
  "class": "fsb header-box"
};
var _hoisted_4 = {
  "class": "my-account"
};
var _hoisted_5 = {
  "class": "header"
};
var _hoisted_6 = {
  "class": "domain-info"
};
var _hoisted_7 = {
  "class": "flex fs"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  key: 0,
  "class": "domain-r"
};
var _hoisted_10 = {
  "class": "address flex-start"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "copy",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "edit-img",
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var _hoisted_13 = {
  key: 1,
  "class": "domain-r"
};
var _hoisted_14 = {
  "class": "address name flex-start"
};
var _hoisted_15 = {
  "class": "name"
};
var _hoisted_16 = {
  "class": "setted-address"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "copy",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_18 = {
  "class": "token fsb"
};
var _hoisted_19 = {
  "class": "flex-start"
};
var _hoisted_20 = ["src"];
var _hoisted_21 = {
  "class": "token-name"
};
var _hoisted_22 = {
  style: {
    "text-align": "right"
  }
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});
var _hoisted_24 = {
  "class": "item-link scrollbar"
};
var _hoisted_25 = ["onClick"];
var _hoisted_26 = {
  "class": "fsb",
  style: {
    "width": "100%"
  }
};
var _hoisted_27 = {
  "class": "left"
};
var _hoisted_28 = ["src"];
var _hoisted_29 = {
  "class": "title"
};
var _hoisted_30 = {
  "class": "right"
};
var _hoisted_31 = {
  key: 0,
  "class": "name less-1"
};
var _hoisted_32 = {
  key: 1,
  "class": "name"
};
var _hoisted_33 = {
  key: 2,
  "class": "name"
};
var _hoisted_34 = {
  key: 3,
  "class": "name"
};
var _hoisted_35 = {
  key: 4,
  "class": "name"
};
var _hoisted_36 = {
  key: 5,
  "class": "name"
};
var _hoisted_37 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }, null, -1);
});
var _hoisted_38 = {
  "class": "btn-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_overlay = _resolveComponent("van-overlay");
  var _component_copy_btn = _resolveComponent("copy-btn");
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_tooltip = _resolveComponent("el-tooltip");
  var _component_gasNumber = _resolveComponent("gasNumber");
  var _component_van_popup = _resolveComponent("van-popup");
  var _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_overlay, {
    show: $data.vantShow,
    onTouchstart: $options.handleTouchstart,
    onTouchmove: $options.handleTouchend,
    onClick: $options.handleClosesBox
  }, null, 8, ["show", "onTouchstart", "onTouchmove", "onClick"]), _createVNode(_component_van_popup, {
    overlay: false,
    show: $data.vantShow,
    "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
      return $data.vantShow = $event;
    }),
    onTouchstart: $options.handleTouchstart,
    onTouchmove: $options.handleTouchend,
    position: "right",
    "with-header": false,
    "class": "shopping-cart-drawer",
    onClose: $options.handleClosesBox
  }, {
    "default": _withCtx(function () {
      return [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("userInfo.my_account")), 1), _createElementVNode("i", {
        onClick: _cache[0] || (_cache[0] = function () {
          return $options.handleClosesBox && $options.handleClosesBox.apply($options, arguments);
        }),
        "class": "close-box"
      })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        "class": "avatar",
        src: $options.headerImg
      }, null, 8, _hoisted_8), !$data.settedDomain ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_copy_btn, {
        address: _ctx.$store.state.account
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString($options.accounts), 1), _hoisted_11];
        }),
        _: 1
      }, 8, ["address"])]), _createVNode(_component_el_button, {
        "class": "title",
        color: "#000",
        onClick: $options.handleSetDomain
      }, {
        "default": _withCtx(function () {
          return [_hoisted_12, _createTextVNode(" " + _toDisplayString(_ctx.$t("myDomain.set_primary_name")), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_tooltip, {
        "class": "box-item",
        effect: "dark",
        content: $data.settedDomain,
        placement: "top",
        persistent: true
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("span", _hoisted_15, _toDisplayString($options.primtyName), 1)];
        }),
        _: 1
      }, 8, ["content"]), _createElementVNode("img", {
        "class": "set-img",
        src: _imports_2,
        onClick: _cache[1] || (_cache[1] = function () {
          return $options.handleSetDomain && $options.handleSetDomain.apply($options, arguments);
        })
      })]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_copy_btn, {
        address: _ctx.$store.state.account
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString($options.accounts), 1), _hoisted_17];
        }),
        _: 1
      }, 8, ["address"])])]))])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
        "class": "token-img",
        src: $options.chainImg
      }, null, 8, _hoisted_20), _createElementVNode("div", _hoisted_21, _toDisplayString($options.chainName), 1)]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_gasNumber, {
        "class": "token-balance",
        usdPrice: $data.balance,
        "is-symbol": true,
        "is-dollar": false,
        height: $options.isMobile ? '1.6rem' : '1rem'
      }, null, 8, ["usdPrice", "height"]), _hoisted_23, _createVNode(_component_gasNumber, {
        "class": "token-dollar",
        usdPrice: $data.dollar,
        height: $options.isMobile ? '1.28rem' : '0.64rem'
      }, null, 8, ["usdPrice", "height"])])])]), _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.linkArr, function (item, i) {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          onClick: function onClick($event) {
            return $options.handleSkip(item.url, item);
          },
          "class": "list"
        }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_28), _createElementVNode("div", _hoisted_29, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_30, [item.key == 4 && $data.userinfo.email ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString($data.userinfo.email), 1)) : _createCommentVNode("", true), item.key == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($data.domainTotal), 1)) : _createCommentVNode("", true), item.key == '5' ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString($data.tldTotal), 1)) : _createCommentVNode("", true), item.key == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$store.state.favoriteCount), 1)) : _createCommentVNode("", true), item.key == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString($data.couponNum), 1)) : _createCommentVNode("", true), item.key == 4 && !$data.userinfo.email ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.$t('email.un_binding')), 1)) : _createCommentVNode("", true), _hoisted_37])])], 8, _hoisted_25);
      }), 128))]), _createElementVNode("div", _hoisted_38, [_createVNode(_component_el_button, {
        "class": "btn",
        color: "#000",
        onClick: $options.handleChangeChainId
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('userInfo.switch_wallets')), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        "class": "btn exit",
        onClick: $options.handLoginOut
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('userInfo.exit_wallet')), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])])), [[_directive_loading, $data.loading]])];
    }),
    _: 1
  }, 8, ["show", "onTouchstart", "onTouchmove", "onClose"])]);
}